import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView"
import { SectionSelectorProps } from "./SectionSelector.types"
import ErrorView from "../SectionError/ErrorView"
import "./SectionSelector.css"
import WorkflowType from "../../../../enums/workflowType"

const SectionSelector = (props: SectionSelectorProps) => {

  const { sections, selectedSection, sectionMetadata, onSelect } = props

  if (sections.status === "loading" || sections.status === "idle") {
    return (
      <SkeletonLoadingView style={{ width: "100%", height: "5em"}} />
    )
  }

  if (sections.status === "error") {
    return (
      <ErrorView message="Failed to load sections."/>
    )
  }

  if (sections.status === "success" && sections.data === null) {
    return (
      <ErrorView message="Failed to find any sections."/>
    )
  }

  return (
    <div className="section-selector-container">
      {sectionMetadata.map((isolatedScan, i) => (
        <>
          {isolatedScan.status === "success" && isolatedScan.data !== null && (
            <p 
              key={i} 
              className={selectedSection === i ? "section-label selected-section" : "section-label"}
              onClick={() => onSelect(i)}
            >
              {sections.data?.[selectedSection].section_type == WorkflowType.ANGULAR ? `Section ${i+1}` : `Patch ${i+1}`} 
            </p>
          )}

          {isolatedScan.status === "loading" && (
            <SkeletonLoadingView style={{ width: "8em", height: "100%"}} />
          )}
        </>
      ))}
    </div>
  )
}

export default SectionSelector